import React, { useEffect, useState } from 'react'
import RosterAndScheduleHomeNavigation from './RosterAndScheduleHomeNavigation'
import './StatsAndStandingsHome.css'
import Banner from './Banner'

const RosterAndScheduleHome = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return (
		<div>
			{/* StatsAndStandingsHomeNavigation contains HomeHeader (just says Stats & Standings)
			and the HomeNavLinks (which is the ADMIN button on the far right) */}
			<RosterAndScheduleHomeNavigation />
			{/* {!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)} */}
			{/* <Banner /> */}
			{/* <div className='rem'>
				<Footer />
			</div> */}
		</div>
	)
}

export default RosterAndScheduleHome
